module.exports = __webpack_public_path__ + "img/image-2.fe971392.svg";